module.exports = __webpack_public_path__ + "img/product9.7ada1b0d.png";